import TimelineAccess, { TimelinePermissions } from "./TimelineAccess";

export default class Folder
{
    public id = -1;
    public name = '';
    public description = '';
    public accessList : TimelineAccess[] = [];
}

export function hasFolderPermission(folder: Folder, userId: string, permission: TimelinePermissions)
{
    const userAccess = folder.accessList.find(x => x.User.userid == userId);
    if (userAccess == null)
        return false;

    return userAccess.Permission >= permission;
}